const $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];

const lbaUrlCtrl = function ($rootScope, $scope, $routeParams, $timeout, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.inputType = vm.settings.inputType || 'url';
  vm.minLength = vm.settings.minLength || 0;
  vm.maxLength = vm.settings.maxLength || 10000000000;
  vm.disabled = false;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  $rootScope.$on(vm.settings.dataAt, () => {
    $timeout(() => {
      vm.data = _.get(dataService.data.activeItem, dataLookUp);
    })
  });

  $rootScope.$on('disableSwitch', (event, data) => {
    if (vm.settings.dataAt === data.lookUp) {
        vm.disabled = !data.value;
        if (!data.value) {
            _.set(dataService.data.activeItem, dataLookUp, null);
            vm.data = _.get(dataService.data.activeItem, dataLookUp);
        }
    }
});
};

lbaUrlCtrl.$inject = $inject;

export default lbaUrlCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaUrl/lbaUrlCtrl.js